import {
  createContext,
  useContext,
  useReducer,
  ReactNode,
  useMemo,
} from 'react';
import { Action, NavigationState, UIProviderProps } from './types';
import { createInitialNavState } from './initialNavState';

const NavUIContext = createContext<NavigationState | any>(undefined);
NavUIContext.displayName = 'UIContext';

const navReducer = (
  state: NavigationState,
  action: Action
): NavigationState => {
  switch (action.type) {
    case 'SET_HEADER_HEIGHT': {
      return {
        ...state,
        headerHeight: action.height,
      };
    }
    case 'SET_IS_TOP': {
      return {
        ...state,
        isTop: action.isTop,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export const UIProvider = ({ children }: UIProviderProps): any => {
  const [state, dispatch] = useReducer(navReducer, createInitialNavState());

  const setHeaderHeight = ({ height }: any) =>
    dispatch({ type: 'SET_HEADER_HEIGHT', height });
  const setIsTop = ({ boolean }: any) =>
    dispatch({ type: 'SET_IS_TOP', isTop: boolean });

  const value = {
    actions: useMemo(
      () => ({
        setHeaderHeight,
        setIsTop,
      }),
      []
    ),
    ...state,
  };

  return (
    <NavUIContext.Provider value={value}>{children}</NavUIContext.Provider>
  );
};

export const NavUIContextProvider = ({ children }: { children: ReactNode }) => (
  <UIProvider>{children}</UIProvider>
);

export const useNavUI = () => {
  const context = useContext(NavUIContext);
  if (context === undefined) {
    throw new Error('useNavUI must be used within a NavUIProvider');
  }
  return context;
};
